import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/landing/Reveal";

export const FAQS = [
  {
    q: "How much does leak detection cost in Perth?",
    a: "With us, $360 for the first half-hour — and that already includes the $200 specialty tool fee and GST. If the leak needs more hunting, it's $45 per 15 minutes after that. Once we've located it, we quote the repair upfront before any work starts. We're the only Perth crew that publishes this on our website.",
  },
  {
    q: "How do you find a leak without ripping up my house?",
    a: "We use non-invasive detective gear: acoustic listening equipment, thermal imaging cameras, moisture meters, pressure testing and, for the really sneaky ones, tracer gas that escapes through the tiniest pinhole and shows us exactly where the leak hides — even under concrete.",
  },
  {
    q: "Do you fix the leak as well, or just find it?",
    a: "Both. Our leak detection technicians are licensed plumbers and gasfitters, so once the leak is found we can repair it on the spot — quoted upfront and backed by our lifetime labour warranty. No handing you off to someone else.",
  },
  {
    q: "My water bill suddenly exploded. Is that a leak?",
    a: "Very likely. An unusually high water bill is one of the most common signs of a hidden leak. Good news: after we repair it, we provide a detailed invoice you can lodge with the Water Corporation — in many cases they'll credit the excess charges back to you.",
  },
  {
    q: "How long does leak detection take?",
    a: "Most leaks are located within the first half-hour. Stubborn leaks — long underground mains, tiny pinholes — can take longer, billed at $45 per 15 minutes. We'll always tell you where things stand before continuing.",
  },
  {
    q: "Do you detect gas leaks too?",
    a: "Yes. Our licensed gasfitters use gas sniffers, digital manometers, compressed air testing, appliance tightness testing and smoke testing. If you smell gas, turn it off at the meter, ventilate the area and call us immediately.",
  },
  {
    q: "Which areas do you service?",
    a: "All of Perth and surrounding suburbs — from Rockingham to Joondalup and beyond. Scroll down for the full suburb list, or book online and we'll confirm your rock-up time.",
  },
  {
    q: "How do I book, and can I really choose the time?",
    a: "Yes — you're looking at the only leak detection booking system in Perth with live availability. Pick a weekday and time slot that suits you (7AM, 9AM, 11AM, 1PM or 3PM), pop in your details, and we'll confirm. Bonus: the first 7AM booking of the day scores a free café coffee.",
  },
];

export const FAQ = ({ limit }) => {
  const faqs = limit ? FAQS.slice(0, limit) : FAQS;
  return (
    <section data-testid="faq-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="font-bold text-xs tracking-[0.3em] text-brand uppercase mb-4">Chapter 07 — Straight answers</p>
          <h2 className="font-bebas text-5xl sm:text-6xl lg:text-7xl text-navy leading-[0.9]">
            QUESTIONS? <span className="text-brand">SORTED.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-14">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-border bg-white px-6 shadow-sm data-[state=open]:border-tpink/60 transition-colors duration-300"
              >
                <AccordionTrigger className="font-bebas text-xl sm:text-2xl tracking-wide text-navy text-left hover:text-brand hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-navy/60 text-sm leading-relaxed pb-6">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};
